const isSpecialLinkClick = (e) => e.metaKey || e.altKey || e.ctrlKey || e.shiftKey;
export {
  isSpecialLinkClick
};
//# sourceMappingURL=isSpecialLinkClick.js.map
